import $ from "jquery";

import {ConnectionFactory, YiiUrlFactory} from "./YiiRoutes";

export class SchoolBlocksAppApi {
    constructor(baseUrl) {
        // These are the root object types that define what type of ID is being passed.  All objects fall into one of
        // these categories.  Anyone using the API should reference the variable, not the value.
        this.rootTypes = {
            ORGANIZATION: "organization",
            PERSON: "people",
            EVENTS: "events"
        };

        this.fieldNames = {
            BLOCK: '_blockHTML',
            MODAL: '_modalHTML',
            AD: '_adHTML',
            GRID_STATES: '_gridStates',
            BLOCKOBJ: '_blockObj',
        };

        this.version = 2;

        this.urlPrefix = '/_!_API_!_';

        // at this time, the url should be an absolute path like '/'.  Eventually, it can be a hostname too
        if (baseUrl === undefined) {
            this.baseUrl = this.urlPrefix;
        } else {
            this.baseUrl = baseUrl;
        }

        this.baseUrl += "/" + this.version;

        this.defaultRequestOptions = {
            crossDomain: false,
            dataType: 'json', // response type from server
        };
    }

    _request(urlPath, locale, orgID, ajaxSettings) {
        var url;

        /*
         API URLs:
         VERB   PATH                            RETURN
         GET    /organizations/<id>?fields=ad,block,modal,permissions  permissions modal HTML (data object later)
         GET    /organizations/<id>/blocks/<id>   all details (can ask ad, block, or modal HTML to be returned)
         GET    /organizations/<id>/blocks/<id>/items/<id>     a sub item, like a specific event that is part of acalendar (modal HTML)
         GET    /people/<id>                    all details (can ask ad, block, or modal HTML to be returned)
         GET    /people/<id>/common             in common with data (future)
         GET    /people/<id>/permissions        permissions modal HTML
         */

        url = YiiUrlFactory("/",locale) + this.baseUrl + urlPath;
        ajaxSettings = $.extend({}, this.defaultRequestOptions, ajaxSettings);
        return ConnectionFactory(orgID, url, ajaxSettings);
    }

    /**
     *
     * @param rootType  One of the SchoolBlocksAppApi.rootTypes
     * @param id        The actual ID for the object being requested
     * @param subPath
     * @param fields  array|null|undefined
     * @param filter  string|null|undefined
     * @param locale  string
     * @param orgID  string
     * @return xhr
     */
    view(rootType, id, subPath, fields, filter, locale, orgID) {
        var ajaxSettings = {
                method: 'GET',
                data: {}
            },
            url;

        if (fields !== null && typeof fields === 'object') {
            ajaxSettings.data.fields = fields.join(",");
        }

        ajaxSettings.data.filter = filter;

        // GET /<type>/<id>
        url = "/" + rootType + "/" + id;
        if (subPath !== undefined && subPath !== null) {
            url += subPath;
        }
        return this._request(url, locale, orgID, ajaxSettings);
    };

    viewOrganization(orgId, blockId, itemId, fields, locale, currentOrgID) {
        var subPath;

        if (blockId !== undefined && blockId !== null) {
            subPath = "/blocks/" + blockId;

            if (itemId !== undefined && itemId !== null) {
                subPath = subPath + "/items/" + itemId;
            }

        }

        return this.view(this.rootTypes.ORGANIZATION, orgId, subPath, fields, undefined, locale, currentOrgID);
    }

    getEventsBetween(calendarId, start, end, locale, orgID) {
        var startTime = start.toISOString(),
            endTime = end.toISOString(),
            filter = [startTime, endTime];

        return this.view(this.rootTypes.EVENTS, calendarId, null, null, filter, locale, orgID);
    }

    viewPerson(personId, fields, locale, orgID) {
        return this.view(this.rootTypes.PERSON, personId, null, fields, undefined, locale, orgID);
    }
}
